<template>
  <base-modal height="600"
              :show="show"
              @close="close" >
    <div slot="header">
      {{ $t("changePassword") }}
    </div>
    <password-change @close="close" />
  </base-modal>
</template>

<script>
  import PasswordChange from '@/components/Common/PasswordChange/PasswordChange.vue'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      PasswordChange
    },

    beforeMount() {
      this.setOpenListener('password')
    }
  }
</script>
